import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { ReservationService } from '../../trip-reservations/reservations.service';
import { Subscription } from 'rxjs/Subscription';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-client-status-manager',
  templateUrl: './client-status-manager.component.html',
  styleUrls: ['./client-status-manager.component.scss']
})
export class ClientStatusManagerComponent implements OnInit, AfterViewInit, OnDestroy {
    public cancelReasons = [];
    public selectedReason: number;
    private removeAllLegs = false;
    @Input() tripstatusid = 0;
    @Input() numberOfLegs = 0;
    @Input() tripid = 0;
    @Input() dateofservice = '3000-12-12';
    @Input() appointment = '12:00';
    @Input() allowReadyToGO: boolean;
    @Input() allowCancelTrip: boolean;
    @Input() leg: string;

    @Output() changedStatus = new EventEmitter<number>();
    public isOpenable = false;
    @ViewChild('ap') public activePopover: T2CardComponent;
    @ViewChild('cp') public cancelPopover: T2CardComponent;
    private observables: Subscription[] = [];

  constructor(
    protected service: ReservationService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.getAllCAncelReasons();
  }
  ngOnInit(  ) {

  }
  ngAfterViewInit() {
      this.validateDate();
      this.validateTripStatus();
  }
  /**
   * @description
   */
  private validateDate() {
      if (!isNaN(new Date( this.dateofservice + ' ' + this.appointment).getTime())) {
          this.isOpenable = new Date().getTime() < new Date(this.dateofservice + ' ' + this.appointment).getTime();
      }
  }

  /**
   * @description
   * @returns {boolean}
   */
  private validateTripStatus() {
      return this.tripstatusid === 1 || this.tripstatusid === 2;
  }

    /**
     * @description
     */
  private hidePopover() {
      this.activePopover.close();
      this.cancelPopover.close();
  }

  /**
   * @description
   * @param newStatus
   */
  public save(newStatus) {
      // tslint:disable-next-line:no-shadowed-variable
      const changeStatus = ( newStatus, allLegs = false) => {
        const data = {
            tripid: this.tripid,
            oldvalue: this.tripstatusid,
            newvalue: newStatus,
            auxvalue: newStatus === 7 ? this.selectedReason : null,
            alllegs: allLegs,
        };
        this.observables.push(
        this.service.editStatus(data).subscribe(
            resp => {
                this.changedStatus.emit(newStatus);
                this.hidePopover();
                this.removeAllLegs = false;
                this.selectedReason = undefined;
            },
            error => {
              this.toastrAlertHelper.error(error.message);
              this.removeAllLegs = false;
              this.selectedReason = undefined;
            }
        ));
      };

      if (newStatus === 7 && this.leg === 'A' && this.numberOfLegs > 1) {
        this.sweetAlertHelper
          .createCustomAlert({
            title: 'Cancel Trip',
            type: 'question',
            text: 'Do you want to cancel the other Legs for this reservation?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
          })
          .then((result) => {
            if (result.value) {
              this.removeAllLegs = true;
            } else {
              this.removeAllLegs = false;
            }
            this.sweetAlertHelper
              .createCustomAlert({
                title: 'Cancel Trip',
                type: 'warning',
                text: 'Are you sure you want to cancel this Reservation/Trip?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                cancelButtonColor: '#d33',
              })
              .then((res) => {
                if (res.value) {
                  changeStatus(newStatus, this.removeAllLegs);
                } else {
                  this.removeAllLegs = false;
                  this.selectedReason = undefined;
                }
              });
          });
      } else if (newStatus === 7) {
        this.sweetAlertHelper
          .createCustomAlert({
            title: 'Cancel Trip',
            type: 'warning',
            text: 'Are you sure you want to cancel this trip?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
          })
          .then((result) => {
            if (result.value) {
              changeStatus(newStatus);
            }
          });
      } else {
        changeStatus(newStatus);
      }

  }

  private getAlertObject(message, type = 'warning') {
      return {
        title: 'Cancel Trip',
        type,
        text: message,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
      };
  }
  /**
   * @description
   * @param {string} button
   */
  public openPopover(button: string) {
      switch (button) {
          case 'active':
              if ( this.activePopover.open(true) ) {
                   this.cancelPopover.close();
                  return;
              }
              this.activePopover.open();
              break;
          case 'cancel':
              if (this.cancelPopover.open( true)) {
                  this.activePopover.close();
                  return;
              }
              break;
      }
  }
  /**
   * get all cancel reasons
   */
  private getAllCAncelReasons() {
    this.observables.push(
      this.service.getCancelReason().subscribe(
        data => this.cancelReasons = data
      ));
  }
  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/clientModules/client-status-manager/client-status-manager.component.ts